const b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764 = {"showInToc":["checkbox",false]}
const b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY = {"buttonType":["radios","standard"]}
const b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI = {"spacing":["radios","small"]}
const b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U = {"spacing":["radios","small"]}
const b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY = {"spacing":["radios","small"]}
const b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo = {"spacing":["radios","small"]}
const b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk = {"spacing":["radios","small"],"imageFormat":["radios","full"]}
const b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90 = {"spacing":["radios","small"],"showInToc":["checkbox",false]}
const b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU = {"spacing":["radios","small"],"color":["radios","gray"]}
const b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y = {"alignment":["radios","left"]}
const b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM = {"spacing":["radios","small"]}
const b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw = {"infoBoxAlignment":["radios","bottom"]}
const b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM = {"spacing":["radios","small"],"teaserStyle":["radios","grid"]}
const b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM = {"spacing":["radios","small"]}
const b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss = {"spacing":["radios","small"],"showInToc":["checkbox",false]}
const b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q = {"spacing":["radios","small"],"format":["radios","text"]}


export const OPTIONS = {
  'b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk': b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk,
  'b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM': b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM,
  'b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90': b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90,
  'b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY': b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY,
  'b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q': b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q,
  'b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764': b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764,
  'b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI': b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI,
  'b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM': b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM,
  'b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y': b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y,
  'b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss': b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss,
  'b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw': b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw,
  'b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U': b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U,
  'b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM': b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM,
  'b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU': b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU,
  'b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo': b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo,
  'b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY': b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY,
  'block:accordeon': b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764,
  'block:button': b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY,
  'block:contact': b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI,
  'block:icon_text_list': b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U,
  'block:iframe': b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY,
  'block:iframe_jobs': b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo,
  'block:image': b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk,
  'block:info_box': b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90,
  'block:link_list': b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU,
  'block:quote': b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y,
  'block:search': b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM,
  'block:teaser': b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw,
  'block:teaser_list': b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM,
  'block:text': b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM,
  'block:title': b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss,
  'block:video': b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q
}


export const FIELD_MAPPING = {
  'accordeon': {
  "paragraphs": "field_content"
},
  'carousel': {
  "slides": "field_slides"
},
  'icon_text_list': {
  "paragraphs": "field_content"
},
  'info_box': {
  "paragraphs": "field_content"
},
  'link_list': {
  "header": "field_header",
  "paragraphs": "field_content"
},
  'search': {
  "header": "field_header"
},
  'teaser_list': {
  "header": "field_header",
  "paragraphs": "field_paragraphs_teaser"
}
}